import {Component, EventEmitter, forwardRef, HostListener, Input, OnChanges, Output, Provider, SimpleChanges} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, ValidationErrors} from '@angular/forms';

export const STARS_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => StarsComponent),
  multi: true
};

export const StarsRequired = (control: AbstractControl): ValidationErrors | null => {
  return control.value > 0 ? null : {required: true};
};

@Component({
  selector: 'stars',
  templateUrl: './stars.component.html',
  styleUrls: ['./stars.component.scss'],
  providers: [STARS_VALUE_ACCESSOR]
})
export class StarsComponent implements OnChanges, ControlValueAccessor {

  @Input() rating = 0;
  @Input() editable = false;

  @Output() update = new EventEmitter<number>();

  stars: number[];

  private onChange: Function;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.reset();
  }

  @HostListener('mouseleave')
  reset() {
    this.stars = Array(5).fill(0)
      .map((_, i) => this.rating >= i + 1 ? 1 : (this.rating > i ? 0.5 : 0));
  }

  highlight(index: number) {
    if (this.editable)
      this.stars = Array(5).fill(0)
        .map((_, i) => i <= index ? 1 : 0);
  }

  select(index: number) {
    if (this.editable) {
      if (this.onChange) {
        this.rating = index + 1;
        this.reset();
        this.onChange(this.rating);
      } else {
        this.update.next(index + 1);
      }
    }
  }

  writeValue(value: number) {
    this.rating = value;
    this.reset();
  }

  registerOnChange(fn: Function) {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function) {
  }
}
